import Vue from 'vue'
import VueRouter from 'vue-router'
import mixin_ from './mixin'
import comps_ from './components'
import routes from './routes'
import App from './Dikobraz'

Vue.config.productionTip = false
Vue.use(VueRouter)

mixin_('deeptensor', true)
comps_()

const router = new VueRouter({mode: 'history', routes})

import VueAnalytics from 'vue-analytics'
Vue.use(VueAnalytics, {
    id: 'UA-110173242-1',
    router,
})

const app = new Vue({
    el: '#app',
    template: '<App/>',
    components: {App},
    router,
    render: function(h) { return h(App) }
})



// WEBPACK FOOTER //
// ./main/main.js